/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FloodSummaryRouteImport } from './routes/flood-summary'
import { Route as EventsCalendarRouteImport } from './routes/events-calendar'
import { Route as EventRouteImport } from './routes/event'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HeatmapColorMetricKeyModeRouteImport } from './routes/heatmap.$colorMetricKey.$mode'

const FloodSummaryRoute = FloodSummaryRouteImport.update({
  id: '/flood-summary',
  path: '/flood-summary',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsCalendarRoute = EventsCalendarRouteImport.update({
  id: '/events-calendar',
  path: '/events-calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const EventRoute = EventRouteImport.update({
  id: '/event',
  path: '/event',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HeatmapColorMetricKeyModeRoute =
  HeatmapColorMetricKeyModeRouteImport.update({
    id: '/heatmap/$colorMetricKey/$mode',
    path: '/heatmap/$colorMetricKey/$mode',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/event': typeof EventRoute
  '/events-calendar': typeof EventsCalendarRoute
  '/flood-summary': typeof FloodSummaryRoute
  '/heatmap/$colorMetricKey/$mode': typeof HeatmapColorMetricKeyModeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/event': typeof EventRoute
  '/events-calendar': typeof EventsCalendarRoute
  '/flood-summary': typeof FloodSummaryRoute
  '/heatmap/$colorMetricKey/$mode': typeof HeatmapColorMetricKeyModeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/event': typeof EventRoute
  '/events-calendar': typeof EventsCalendarRoute
  '/flood-summary': typeof FloodSummaryRoute
  '/heatmap/$colorMetricKey/$mode': typeof HeatmapColorMetricKeyModeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/event'
    | '/events-calendar'
    | '/flood-summary'
    | '/heatmap/$colorMetricKey/$mode'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/event'
    | '/events-calendar'
    | '/flood-summary'
    | '/heatmap/$colorMetricKey/$mode'
  id:
    | '__root__'
    | '/'
    | '/event'
    | '/events-calendar'
    | '/flood-summary'
    | '/heatmap/$colorMetricKey/$mode'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EventRoute: typeof EventRoute
  EventsCalendarRoute: typeof EventsCalendarRoute
  FloodSummaryRoute: typeof FloodSummaryRoute
  HeatmapColorMetricKeyModeRoute: typeof HeatmapColorMetricKeyModeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/flood-summary': {
      id: '/flood-summary'
      path: '/flood-summary'
      fullPath: '/flood-summary'
      preLoaderRoute: typeof FloodSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events-calendar': {
      id: '/events-calendar'
      path: '/events-calendar'
      fullPath: '/events-calendar'
      preLoaderRoute: typeof EventsCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event': {
      id: '/event'
      path: '/event'
      fullPath: '/event'
      preLoaderRoute: typeof EventRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/heatmap/$colorMetricKey/$mode': {
      id: '/heatmap/$colorMetricKey/$mode'
      path: '/heatmap/$colorMetricKey/$mode'
      fullPath: '/heatmap/$colorMetricKey/$mode'
      preLoaderRoute: typeof HeatmapColorMetricKeyModeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EventRoute: EventRoute,
  EventsCalendarRoute: EventsCalendarRoute,
  FloodSummaryRoute: FloodSummaryRoute,
  HeatmapColorMetricKeyModeRoute: HeatmapColorMetricKeyModeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
